import * as React from 'react';

export const LoadingSpinner = () => {
  return (
    <div className="animate-pulse">
      <span>Loading...</span>
    </div>
  );
};
